import { Component, Inject, OnInit,  } from '@angular/core';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';

export interface SopoSelectListData<T> {
    title?: string,
    list?: T[],
    listObject?: {value: T , text: string}[],
    listText?: string,
    selected?: T,
    multipleSelection?: boolean,
}

@Component({
    selector: 'app-sopo-select-list',
    templateUrl: './sopo-select-list.component.html',
    styleUrls: ['./sopo-select-list.component.scss'],
    standalone: false
})
export class SopoSelectListComponent<T> implements OnInit {
    title: string = '';
    list: T[] = [];
    listObject: {value: T , text: string}[] = [];
    listText: string = '';
    selected: T;

    constructor(
        private sopoDialogRef: SopoDialogRef,
        @Inject(SOPO_DIALOG_DATA) data: SopoSelectListData<T>,
    ) { 
        if (data.title !== undefined) this.title = data.title;
        if (data.list !== undefined) this.list = data.list;
        if (data.listObject !== undefined) this.listObject = data.listObject;
        if (data.listText !== undefined) this.listText = data.listText;
        if (data.selected !== undefined) this.selected = data.selected;
    }

    ngOnInit() { }

    changeSelected(selectedItem) {
        this.selected = selectedItem;
        this.sopoDialogRef.close(selectedItem);
    }
}
